/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Delete from './Delete/index'
import Edit from './Edit/index'
import React from 'react'
import ThreeDotsMenu from 'DesignSystem/ThreeDotsMenu/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/MoreActions/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let imageSerieDeletedValueData = fromData.useDataValue({ viewPath,
context: 'image_serie',
path: 'deleted',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<ThreeDotsMenu
  viewPath={`${viewPath}/ThreeDotsMenu`}
 onClick={onClick}
 data="options"
 from={optionsValueData}
 paddingTop={0}
 paddingLeft={0}
 paddingBottom={0}
 paddingRight={0}
 width={300}
 right={0}
 valueWidth="auto"
 selectedBackgroundColor="transparent"
 skipCallingOnClickWhenMoreThanOneItemAndNoneSelected={true}
 height={imageSerieDeletedValueData ? "45px" : "86px"}
 data="image_serie.deleted"
/>
</div>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
{children}
</React.Fragment>)
}